import { BadgeCheck } from "lucide-react";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";
import { IMAGES } from "@/data/services";

export default function AboutPage() {
  return (
    <PageLayout eyebrow="About Us" title="Who is" titleAccent="Brad's Mobile Detailing?">
      <PageBody>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-base text-slate-300 leading-relaxed">
              Brad's Mobile Detailing is a mobile detailing service based in
              Charlotte, NC and surroundings. We are a fully-equipped mobile detailing service,
              which means we travel to the location of your choice with our own equipment, supplies,
              water and electricity.
            </p>
            <p className="mt-4 text-base text-slate-400 leading-relaxed">
              We cater to clients who enjoy the luxury of a detailing service without having to
              sacrifice convenience. Kick back, relax and enjoy the comfort of your home or office
              while we make your vehicle look beautiful again. We also have contracts with big and
              small dealerships all over town — we are currently detailing about 60 cars and
              trucks every month.
            </p>
            <div className="mt-7">
              <BookNowButton to="/book" label="Book Your Detail Now" testid="about-page-book-button" />
            </div>
          </div>
          <div className="relative max-w-md mx-auto w-full">
            <img src={IMAGES.ceo} alt="Brad, CEO and Founder of Brad's Mobile Detailing" className="w-full aspect-[3/4] object-cover max-h-[540px] border-2 border-[#EA0A0B]" />
          </div>
        </div>

        <div className="mt-16 bg-[#121216] border border-[#232329] p-7 md:p-10">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#EA0A0B]">Quality of Service</p>
          <h2 className="mt-4 font-display uppercase text-2xl md:text-3xl tracking-wide text-white leading-snug">
            Brad's Mobile Detailing, LLC offers high quality auto detailing and reconditioning services in
            the Charlotte area.
          </h2>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
            Brad — CEO and Founder · Brad's Mobile Detailing
          </p>
          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
            {[
              "Professional equipment and fully trained staff",
              "Complete satisfaction on every service",
              "Licensed and fully insured company",
              "Detailing that protects your resale value",
            ].map((c) => (
              <li key={c} className="flex items-start gap-2.5 text-sm text-slate-200">
                <BadgeCheck className="w-5 h-5 text-[#EA0A0B] shrink-0" />
                {c}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 bg-[#121216] border border-[#232329] p-7 md:p-10">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#EA0A0B]">A great value services</p>
          <h2 className="mt-4 font-display uppercase text-2xl md:text-3xl tracking-wide text-white">Why Choose Us</h2>
          <p className="mt-4 text-base text-slate-300 leading-relaxed">
            Our goal at Brad's Mobile Detailing is to offer the "BEST VALUE" in auto detailing. We take
            pride in offering the "BEST" quality in mobile auto detailing at the most affordable
            rates. We prefer to be known as an "EVERYMAN" wash, not just catering to the Porsche and
            Mercedes crowd. Every customer will receive an honest, workman like effort at a fair and
            reasonable price.
          </p>
        </div>

        <div data-testid="about-page-community" className="mt-10 bg-[#121216] border border-[#232329] p-7 md:p-10">
          <div className="flex flex-col md:flex-row md:items-center gap-8">
            <div className="flex-1">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#EA0A0B]">Giving Back</p>
              <h2 className="mt-4 font-display uppercase text-2xl md:text-3xl tracking-wide text-white">Community First</h2>
              <p className="mt-4 text-base text-slate-300 leading-relaxed">
                Brad's Mobile Detailing is proud to give back to the community that supports us. We
                sponsor local youth football teams and coach Little League on the side — because for
                us, this business has always been about more than clean cars. When you book with us,
                you're supporting a local small business that invests right back into Charlotte.
              </p>
            </div>
            <img
              src="/gallery/coach.jpg"
              alt="Brad coaching a Little League player — community first at Brad's Mobile Detailing"
              data-testid="about-page-community-image"
              className="w-full md:w-72 lg:w-80 shrink-0 object-cover aspect-[3/4] max-h-96 border-2 border-[#EA0A0B]"
            />
          </div>
        </div>
      </PageBody>
    </PageLayout>
  );
}
